import styled from 'styled-components/macro';
import * as PopoverPrimitive from '@radix-ui/react-popover';

export const Popover = styled(PopoverPrimitive.Root)``;
